import { z } from 'zod';
import { MaxStepsSchema } from './settings.js';
// Sentinel placeholder used until a real title has been generated. Returned
// by the API as-is for consumers without i18n (e.g. the admin console); the
// front compares against this constant to render a localized placeholder.
export const NEW_CONVERSATION_TITLE = 'New conversation';
export const ConversationSchema = z.object({
    id: z.string(),
    title: z.string(),
    archivedAt: z.iso.datetime().optional(),
    archivedBy: z.string().optional(),
    // Per-conversation override of the user-level summarization opt-in.
    // Undefined means "inherit from user settings".
    summarizationEnabled: z.boolean().optional(),
    // Per-conversation override of the user-level max agent steps.
    // Undefined means "inherit from user settings".
    maxSteps: MaxStepsSchema.optional(),
    // The model this conversation runs on. NOT an override that inherits: it is
    // written through on the first turn and then held, so a conversation does not
    // drift when the user changes their default. Undefined means the first turn
    // has not run yet.
    model: z.string().optional(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime()
});
export const CreateConversationRequestSchema = z.object({
    title: z.string().optional()
});
// PATCH /conversations/:id payload. Only mutable settings appear here.
// A `null` value clears an override (falls back to the user-level value);
// `title` is a manual rename.
export const UpdateConversationSettingsRequestSchema = z.object({
    title: z.string().trim().min(1).max(200).optional(),
    summarizationEnabled: z.boolean().nullable().optional(),
    maxSteps: MaxStepsSchema.nullable().optional(),
    // Accepted already, so the conversation-settings panel to come needs no
    // back-end change. Null re-opens the pin: the next turn resolves it again.
    model: z.string().min(1).nullable().optional()
});
